import './App.css';
import React, { useEffect } from 'react';
import { applyPrinterPageStyle } from './utils/printerSettings';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoadingSpinner from './components/LoadingSpinner';

import Layout from './layouts/Layout';
import ProtectedLayout from './layouts/ProtectedLayout';
import PublicRoute from './components/PublicRoute';

import Login from 'pages/Login';
import ElectronLogin from 'pages/ElectronLogin';

import PinVerification from 'pages/PinVerification';
import BranchSelector from 'pages/BranchSelector';

import POSDeviceManagement from 'pages/POSDeviceManagement';
import CashDrawerManagement from 'pages/CashDrawerManagement';
import POSCashStartReceipt from 'pages/POSCashStartReceipt';

import POS from 'pages/pos-menus/pos/POS';
import Notification from './pages/pos-menus/Notification';
import Table from './pages/pos-menus/Table';
import Bill from 'pages/pos-menus/bill/Bill';
import Shop from './pages/pos-menus/Shop';
import Menu from 'pages/pos-menus/Menu';
import Save from './pages/pos-menus/Save';

import NotFound from './pages/NotFound';

import KitchenLayout from './layouts/KitchenLayout';
import KitchenPage from './pages/pos-menus/kitchen/Kitchen';
import KitchenHistoryPage from './pages/pos-menus/kitchen/KitchenHistory';
import CheckerPage from './pages/pos-menus/kitchen/CheckerPage';
import CloseBalancePrint from './pages/CloseBalancePrint';
import PosStartPrintPage from './pages/PosStartPrintPage';
import ReceiptPrintPage from './pages/ReceiptPrintPage';
import PosDepositPrintPage from './pages/PosDepositPrintPage';
import PosWithdrawPrintPage from './pages/PosWithdrawPrintPage';
import PosOpenStorePrintPage from './pages/PosOpenStorePrintPage';
import QrTablePrintPage from './pages/QrTablePrintPage';

function RootRedirect() {
  const slug = localStorage.getItem('businessSlug');
  const accessToken = localStorage.getItem('accessToken');
  if (slug && accessToken) {
    return <Navigate to={`/${slug}/`} replace />;
  }
  return <Navigate to="/login" replace />;
}

function App() {
  const loading = useSelector(state => state.common.loading);

  useEffect(() => {
    applyPrinterPageStyle();
  }, []);

  return (
    <>
      <Routes>
        <Route path="/login" element={<ElectronLogin />} />
        <Route path="/" element={<RootRedirect />} />
        <Route element={<ProtectedLayout />}>
          <Route element={<PublicRoute />}>
            <Route path="/:businessSlug/login" element={<Login />} />
          </Route>
          <Route path="/:businessSlug/branch-selection" element={<BranchSelector />} />
          <Route path="/:businessSlug/verify-pin" element={<PinVerification />} />
          <Route path="/:businessSlug/pos-setting" element={<POSDeviceManagement />} />
          <Route path="/:businessSlug/money-drawer" element={<CashDrawerManagement />} />
          <Route path="/:businessSlug/pos-start-print" element={<POSCashStartReceipt />} />

          <Route path="/:businessSlug/close-balance-print" element={<CloseBalancePrint />}></Route>
          <Route path="/:businessSlug/pos-start-print" element={<PosStartPrintPage />}></Route>

          <Route path="/:businessSlug/recipt-print" element={<ReceiptPrintPage />}></Route>
          <Route path="/:businessSlug/recipt-print-copy" element={<ReceiptPrintPage $isCopy={true} />}></Route>
          <Route path="/:businessSlug/recipt-print-invoice" element={<ReceiptPrintPage $isInvoice={true} />}></Route>

          <Route path="/:businessSlug/pos-deposit-print" element={<PosDepositPrintPage />}></Route>
          <Route path="/:businessSlug/pos-withdraw-print" element={<PosWithdrawPrintPage />}></Route>
          <Route path="/:businessSlug/pos-open-store-print" element={<PosOpenStorePrintPage />}></Route>
          <Route path="/:businessSlug/qr-table-print" element={<QrTablePrintPage />}></Route>

          <Route path="/:businessSlug" element={<Layout />}>
            <Route index element={<POS />} />
            <Route path="notification" element={<Notification />} />
            <Route path="table" element={<Table />} />
            <Route path="bill" element={<Bill />} />
            <Route path="save" element={<Save />} />
            <Route path="menu" element={<Menu />} />
            <Route path="shop" element={<Shop />} />
          </Route>
          <Route path="/:businessSlug" element={<KitchenLayout />}>
            <Route path="kitchen" element={<KitchenPage />} />
            <Route path="kitchen-history" element={<KitchenHistoryPage />} />
            <Route path="checker" element={<CheckerPage />} />
          </Route>
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>

      <LoadingSpinner isLoading={loading} />
    </>
  );
}

export default App;
